><template>
    <div v-if="item.history && item.history.length > 0" class="mt-2">
        <div v-for="(history, index) in item.history" :key="index">
            <li v-if="!isInternalUser && history.isFile">
                <span v-if="history.isFile">
                        Attached <a href="#" @click.prevent="downloadFile(history.link)">{{ history.bag.storageFile.fileName }}</a> <i class="fa fa-paperclip"></i>
                </span>
            </li>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        async downloadFile(fileLink) {
            await romeApi.download(`${this.item.employerId}/${fileLink}`);
        },
    },
    computed: {
    ...amfx.map("session", "isInternalUser"),
    }
}
</script>



// WEBPACK FOOTER //
// src/action-items/types/FilesUploaded.vue